
import "@/views/mixins/mobile-portal.scss"
import CommonMixin from "@/common/mixins/common-mixin";
export default {
    mixins: [CommonMixin],
    data() {
        return {
            show_reels: null,
            show_reel_height: 200,
            live: null,
            playback: null,
            debounced:false,
        }
    },
    watch: {
        filter() {
            const vm = this;
            if (!this.debounced) {
                this.debounced = this.$debounce(1000, function () {
                    vm.loadEvents();
                });
            }
            this.debounced();
        }
    },
    computed: {
        filter() {
            return this.process.filter;
        }
    },
    methods: {
        handleResize() {
            this.show_reel_height = document.body.clientWidth * 9 / 16;
            const saved = this.show_reels;
            this.$nextTick(function () {
                this.show_reels = saved;
            })
            this.show_reels = null;
        },
        loadEvents() {
            this.$api("Admin.Portal.Suggestion", {filter: this.process.filter}, true).then(res => {
                const data = res.data.data;
                this.live = data['live']
                this.playback = data['playback'];
            });
        },
        loadShowReels() {
            this.$api("Admin.Portal.ShowReels", {}, 1).then(res => {
                this.show_reels = res.data.data;
            })
        },
    }
}
